/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { Pair } from './pair';

export interface TwapOrderWithFilledPartDto {
  id?: number;
  accountId?: number;
  account?: Account;
  pairId?: number;
  pair?: Pair;
  side?: TwapOrderWithFilledPartDto.SideEnum;
  quantity?: number;
  baseAsset?: boolean;
  startTime?: string;
  mode?: TwapOrderWithFilledPartDto.ModeEnum;
  finishTime?: string;
  tradesDelay?: number;
  childTradeQuantity?: number;
  status?: TwapOrderWithFilledPartDto.StatusEnum;
  randomTradesDelayPercent?: number;
  randomTradesQuantity?: number;
  slippageTolerance?: number;
  maxAcceptableSpread?: number;
  minPrice?: number;
  maxPrice?: number;
  filledQty?: number;
  averagePrice?: number;
  filledVolume?: number;
  lastChildOrderSendTime?: string;
  lastChildOrderMessage?: string;
}
export namespace TwapOrderWithFilledPartDto {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
  export const ModeEnum = {
    DelayAndChildTradeQuantity: 'DELAY_AND_CHILD_TRADE_QUANTITY',
    FinishTimeAndDelay: 'FINISH_TIME_AND_DELAY',
    FinishTimeAndChildTradeQuantity: 'FINISH_TIME_AND_CHILD_TRADE_QUANTITY',
  } as const;
  export type ModeEnum = (typeof ModeEnum)[keyof typeof ModeEnum];
  export const StatusEnum = {
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    Cancelling: 'CANCELLING',
    Done: 'DONE',
    Cancelled: 'CANCELLED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
